export default {
  edit: {
    title: 'Edit Profile',
    subTitle: 'Edit Form',
    editButton: 'Edit'
  },
  generalInformations: 'General informations',
  myProfile: 'My profile',
  myInformations: 'My informations',
  caregivers: 'My caregivers',
  changePassword: 'Changer my password',
  notifications: {
    label: 'Notifications management',
    disable: 'I want to disable all notifications',
    dailySynthesis: {
      enable: 'I want a daily synthesis',
      label: 'Daily synthesis',
      description1: 'A daily synthesis will be send to you each morning.',
      description2: 'This synthesis contains all important information of the day:',
      newDocuments: 'New documents',
      newMessages: 'New messages',
      newTherapeuticContents: 'New therapeutic contents',
      surveys: 'Surveys',
      calendarEvents: 'Appointments/reminders'
    },
    individualNotifications: {
      label: 'Individual notifications',
      enable: 'I want to manage my notifications individually'
    }
  },
  iot: 'Connected devices',
  chooseLanguage: 'Choose language',
  timezone: {
    label: 'Time zone',
    select: 'Choose your time zone',
    search: 'Search for a time zone',
    auto: 'Automatic ({timezone})',
    name: '({offset}) {name}',
    current: 'Current time zone:',
    new: 'New time zone:',
    updateSuccess: 'Your time zone has been updated. The page will be updated',
    updateError: 'Unable to update your time zone'
  },
  help: 'Documentation and help',
  onlineHelp: 'Online help',
  userManual: 'User manuel',
  legalMentions: 'Legal mentions',
  eula: 'EULA',
  about: 'About',
  disconnect: 'Disconnect',
  menu: 'Back to menu',
  password: 'Password',
  editProfile: {
    title: 'Edit my profile',
    emailAddress: 'Email address',
    addAddress: 'Add an address',
    phone: 'Phone',
    addPhone: 'Add a phone number',
    phoneNumber: 'Phone number'
  },
  endUserLevelAgreement: 'End-user level agreement',
  otp: {
    invalidCode: 'Invalid code'
  },
  emailUpdate: {
    info: 'You can define a new email address for your account.',
    validationCode: 'To ensure that this address is really yours, we will send you a validation code.',
    waitBeforeRetry: 'Please wait {duration} before retry',
    sentValidationCode: 'To ensure that this address is really yours, we have sent a validation code to your new address.',
    verifyCode: 'Verify the code',
    success: 'The email address has been successfully updated',
    error: {
      alreadyUsedEmailAddress: 'The email address has already been used'
    }
  },
  mobilePhoneUpdate: {
    info: 'You can define a new phone number for your account.',
    validationCode: 'To ensure that this address is really yours, we will send you a validation code by SMS.',
    waitBeforeRetry: 'Please wait {duration} before retry',
    sentValidationCode: 'To ensure that this address is really yours, we have sent a validation code to your new phone number.',
    verifyCode: 'Verify the code',
    success: 'The phone number has been successfully updated'
  }
}
